import(/* webpackMode: "eager", webpackExports: ["CopyToClipboardButton"] */ "/opt/buildhome/repo/components/CopyToClipboardButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkeletonImage"] */ "/opt/buildhome/repo/components/SkeletonImage.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
